function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.16667 3.02647L23.8333 3.02647L23.8333 24.8206H14.4444V27H23.2667C24.7809 27 26 25.7691 26 24.2506L26 3.59645C26 2.07346 24.7763 0.847059 23.2667 0.847059L2.73332 0.847059C1.21923 0.847059 1.90735e-06 2.0781 1.90735e-06 3.59645L1.90735e-06 12.4705H2.16667L2.16667 3.02647Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.73334 27L7.94456 27V24.8206H3.51399L18.8278 9.41671C19.2293 9.01285 19.2291 8.35943 18.8282 7.95617C18.4247 7.55022 17.7774 7.55322 17.3764 7.95677L2.16669 23.2558V19.0087L2.28882e-05 19.0087V24.2506C2.28882e-05 25.7736 1.22386 27 2.73334 27Z",
  fill: "currentColor"
});

var SvgIcModalClose = function SvgIcModalClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcModalClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_modal_close.db65513c.svg";
export { ForwardRef as ReactComponent };